import React, { useEffect, useRef, useState } from 'react';
import './RadioPlayerWidget.css';

const RadioPlayerWidget = () => {
  const containerRef = useRef(null);
  const audioRef = useRef(new Audio());
  const [isPlaying, setIsPlaying] = useState(false);
  const [metadata, setMetadata] = useState(null);
  const [elapsed, setElapsed] = useState(0);

  const config = {
    streamUrl: 'https://s107.radiolize.com:8090/radio.mp3',
    apiUrl: 'https://s107.radiolize.com/api/nowplaying/10'
  };

  useEffect(() => {
    const audio = audioRef.current;
    audio.src = config.streamUrl;
    audio.preload = 'none';

    const fetchMetadata = async () => {
      try {
        const response = await fetch(config.apiUrl);
        const data = await response.json();
        setMetadata(data);
        if (data.now_playing) {
          setElapsed(Math.max(0, data.now_playing.elapsed || 0));
        }
      } catch (error) {
        console.error('Error fetching metadata:', error);
      }
    };

    fetchMetadata();
    const metaInterval = setInterval(fetchMetadata, 10000);
    
    const timerInterval = setInterval(() => {
      setElapsed(prev => prev + 1);
    }, 1000);

    return () => {
      clearInterval(metaInterval);
      clearInterval(timerInterval);
      audio.pause();
      audio.src = '';
    };
  }, []);

  const togglePlay = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play().catch(console.error);
    }
    setIsPlaying(!isPlaying);
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const nowPlaying = metadata?.now_playing;
  const duration = nowPlaying?.duration || 0;
  const progress = duration > 0 ? (elapsed / duration) * 100 : 0;

  return (
    <div className="radio-widget-container mb-8">
      <h3 className="text-lg font-bold text-gray-900 mb-4 px-1">Radio - Live</h3>
      <div ref={containerRef} className="radio-player horizontal">
        <div className="station-row">
          <div className="live-container" style={{ display: metadata?.live?.is_live ? 'flex' : 'none' }}>
            <div className="live-indicator"></div>
            <div className="live-text">{metadata?.live?.streamer_name || 'LIVE'}</div>
          </div>
        </div>

        <div className="content-row">
          <div className="artwork-column">
            <div className="album-artwork">
              {nowPlaying?.song?.art ? (
                <img className="artwork-image" src={nowPlaying.song.art} alt="Album Art" />
              ) : (
                <div className="artwork-placeholder text-[10px] text-center p-2 uppercase font-bold opacity-30">
                  Effekten Radio
                </div>
              )}
            </div>
          </div>
          
          <div className="player-info">
            <div className="song-info">
              <div className="song-name truncate">{nowPlaying?.song?.title || 'Laddar...'}</div>
              <div className="artist-name truncate">{nowPlaying?.song?.artist || 'Effekten'}</div>
            </div>

            <div className="controls-container">
              <div className="controls">
                <button onClick={togglePlay} className="control-button play-button">
                  <i className={`fas fa-${isPlaying ? 'pause' : 'play'}`}></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-4">
          <div className="time-bar">
            <div className="time-bar-progress" style={{ width: `${Math.min(progress, 100)}%` }}></div>
          </div>
          <div className="time-info">
            <span>{formatTime(elapsed)}</span>
            <span>{formatTime(duration)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RadioPlayerWidget;